// First, create an event bus file
import Vue from 'vue'
export const eventBus = new Vue()